module.exports = __webpack_public_path__ + "static/media/tab_4.59973ef5.png";